<template>
  <div v-if="visible">
    <div class="tit_tl" @click="goDown">打开APP，查看全部评论</div>
    <GCDOWN :down-show="DownShow" @showDwon="getshowDonw" />
    <GCGUIDE :down-show="weiXin" @showDwon="getWechat" />
  </div>
</template>
<script>
import utils from '@/utils/utils'
import GCDOWN from '@/components/gc-down'
import GCGUIDE from '@/components/gc-guide'
export default {
  components: {
    GCDOWN,
    GCGUIDE
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: this.isShow,
      weiXin: false,
      DownShow: false
    }
  },
  created() {
  },
  methods: {
    goDown() {
      if (utils.is_weixn()) {
        this.weiXin = true
      } else {
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        const pid = isAndroid ? 1 : 2
        if (isAndroid) {
          window.location.href = 'cn.com.greatchef://?params={"des":"articlesview","skuid":' + this.$route.query.id + '}'
        } else {
          window.location.href = 'com.greatchef.notes://?params={"des":"articlesview","skuid":' + this.$route.query.id + '}'
        }
        setTimeout(() => {
          this.DownShow = true
        }, 2000)
      }
    },
    goClose() {
      this.visible = false
    },
    getshowDonw(val) {
      this.DownShow = false
    },
    getWechat(val) {
      this.weiXin = false
    }
  }
}
</script>
